module.exports = __webpack_public_path__ + "static/featured-companies-ebb00517866ec090e2a237d77c357653.png";